const specialAcronyms = {
  hr: "HR",
  id: "ID",
  url: "URL",
  // Add more acronyms as needed
};

export const keyToTitle = (key) => {
  // Split by capital letters and spaces
  const words = key.split(/(?=[A-Z])|(?:\s+)/);

  return words
    .map((word) => {
      // Check if word should be an acronym
      const lowerWord = word.toLowerCase();
      if (specialAcronyms[lowerWord]) {
        return specialAcronyms[lowerWord];
      }
      // Capitalize first letter
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

// Usage examples:
// keyToTitle('firstName') => 'First Name'
// keyToTitle('employeeShortName') => 'Employee Short Name'
// keyToTitle('hrManager') => 'HR Manager'
// keyToTitle('dateOfJoining') => 'Date Of Joining'
